import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
  MenuItem,
} from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CustomButton from "./CusomButton";
import Dropzone from "react-dropzone";
import PublishIcon from "@material-ui/icons/Publish";
import FileViewer from "./FileViewer";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import moment from "moment";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "16px",
    border: "1px solid #ddd",
  },
  fileLink: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  remarks: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderTop: "1px solid #ddd",
    margin: theme.spacing(1, 0),
  },
  button: {
    backgroundColor: "#FF9677",
    color: "#fff",
    marginTop: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#FF9677",
    },
  },
}));

const supportingFiles = [
  {
    fileName: "supporting_data.pdf",
    fileLink: "path/to/supporting_data.pdf",
    lastUpdatedDate: "2024-09-27 07:43:30",
  },
];

const ExceptionCollabpisbleRow = (props) => {
  const {
    open,
    projectData,
    row,
    deliverablesData,
    workItemDetails,
    exceptionRow,
  } = props;
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [versionCount, setVersionCount] = useState(null);
  const [latestFile, setLatestFile] = useState(null);
  //   const versionCount = cdmoFileDetails.length;
  //   const latestFile = sponsorFileDetails[sponsorFileDetails.length - 1];

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cdmoFileDetails, setCdmoFileDetails] = useState([]);
  const [sponsorFileDetails, setSponsorFileDetails] = useState([]);
  const [supportingFiles, setSupportingFileDetails] = useState([]);
  const [approveClicked, setApproveClicked] = useState(false);
  // const [SMEUserName, SetSMEUserName] = useState(
  //   exceptionRow.sponsorSMEUserNameList[0]
  // );

  const handleApproveClick = () => {
    setApproveClicked(true);
  };

  useEffect(() => {
    let url = null;

    const data = {
      collabrixWorkItemID: 0,//row.collabrixWorkItemID
      eventID: exceptionRow.collabrixExceptionID,
      sponsorOrgID: deliverablesData.sponsorOrgID,
      cdmoOrgID: deliverablesData.cdmoOrgID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          const supportingFilteredFiles = res.data.data.cdmoFileDetails.filter(
            (file) => file.fileType === "supporting_file"
          );

          setSupportingFileDetails(supportingFilteredFiles);
          const cdmoScientificFilteredFiles =
            res.data.data.cdmoFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );
          setCdmoFileDetails(cdmoScientificFilteredFiles);
          const sponsorScientificFilteredFiles =
            res.data.data.sponsorFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );

          setSponsorFileDetails(sponsorScientificFilteredFiles);
          setVersionCount(res.data.data.cdmoFileDetails.length);
          setLatestFile(
            sponsorScientificFilteredFiles[
              sponsorScientificFilteredFiles.length - 1
            ]
          );
          setIsLoading(false);
        } else {
          setError("Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        //console.log(err);
        setError("Something went wrong. Please try again.");
      });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleFileClick = (file) => {
    // Set the clicked file in the state to open the dialog
    setSelectedFile(file);
    setDialogOpen(true); // Open the dialog when a file is clicked
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  const [remarks, setRemarks] = useState("");
  const [qaRemarks, setQARemarks] = useState("");

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const profileDetails = useSelector((state) => state.user.userDetails || {});

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                }}
              >
                <CircularProgress />
              </div>
            ) : error ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
              </div>
            ) : (
              <Box margin={1}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Typography variant="h6">
                      {deliverablesData.cdmoOrgName}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {cdmoFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={4}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {new Date(
                                  file.lastUpdatedDate
                                ).toLocaleString()}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            <Grid item xs={8} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              {index === 0 && versionCount === 1 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks:
                                </Typography>
                              ) : index > 0 ? (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Resubmission Remarks:
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks:
                                </Typography>
                              )}
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks
                                  ? file.uploadRemarks
                                  : "-NA-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}

                      {/* Add "Remind Sponsor Team" button */}
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Grid
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              paddingTop: "14px",
                            }}
                          >
                            <CustomButton
                              color="#F26336" // Custom orange background
                              hoverColor="#D8542E" // Darker orange on hover
                              textColor="#fff" // Explicitly set white text color
                              disabled={
                                localStorage.collabType === "Pharma Co"
                                  ? true
                                  : false
                              }
                            >
                              Remind BMS Team
                            </CustomButton>
                          </Grid>
                        </Grid>
                      </Grid>
                      {supportingFiles.length > 0 && (
                        <>
                          <Grid container spacing={3}>
                            <Grid xs={12}>
                              <div className={classes.divider}></div>
                            </Grid>
                          </Grid>

                          {/* Supporting Files */}
                          <Grid container spacing={3}>
                            {supportingFiles.map((file, index) => (
                              <>
                                <Grid item xs={4}>
                                  <Typography
                                    variant="subtitle1"
                                    style={{ marginTop: "20px" }} // Added margin for better spacing
                                  >
                                    {index === 0 ? "Supporting Files" : ""}
                                  </Typography>
                                </Grid>

                                <Grid
                                  container
                                  item
                                  xs={8}
                                  key={index}
                                  alignItems="flex-start"
                                  className={classes.fileLink}
                                  style={{ marginTop: "20px" }} // Added margin for better spacing
                                >
                                  {/* File Icon and Name */}
                                  <Grid container alignItems="center">
                                    <PublishIcon className={classes.icon} />
                                    <Link
                                      href={file.fileLink}
                                      target="_blank"
                                      rel="noopener"
                                      style={{
                                        marginRight: "8px",
                                        cursor: "pointer",
                                      }}
                                      color="secondary"
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevent default link action
                                        handleFileClick(file); // Trigger the state change to open the component
                                      }}
                                    >
                                      {file.fileName}
                                    </Link>
                                  </Grid>

                                  {/* Date below the file name */}
                                  <Grid item xs={12}>
                                    <Typography
                                      variant="body2"
                                      color="textSecondary"
                                    >
                                      {new Date(
                                        file.lastUpdatedDate
                                      ).toLocaleString()}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ))}
                          </Grid>
                        </>
                      )}
                    </Paper>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="h6">
                      {deliverablesData.sponsorOrgName}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {sponsorFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={5}>
                              <Typography variant="subtitle1">
                                Version {file.versionNumber} (with edits)
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {new Date(
                                  file.lastUpdatedDate
                                ).toLocaleString()}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            {file.fileName !== null ||
                            file.fileName !== undefined ||
                            file.fileName !== "" ? (
                              <Grid item xs={7} className={classes.fileLink}>
                                <PublishIcon className={classes.icon} />
                                <Link
                                  href={file.fileLink}
                                  target="_blank"
                                  rel="noopener"
                                  color="secondary"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default link action
                                    handleFileClick(file); // Trigger the state change to open the component
                                  }}
                                >
                                  {file.fileName}
                                </Link>
                              </Grid>
                            ) : (
                              <Grid item xs={7}>
                                <Typography>-NA-</Typography>
                              </Grid>
                            )}
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Approve / Reject Remarks
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}

                      {/* Conditionally render the upload section if the latest file is rejected */}
                      {/* {exceptionRow?.requireSponsorSMEReview === true && ( */}
                      {localStorage.collabType === "Pharma Co" && (
                        <>
                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}>
                              {!approveClicked &&
                              exceptionRow?.requireSponsorSMEReview === true ? (
                                <CustomButton
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff" // Explicitly set white text color
                                  fontSize="0.275rem"
                                >
                                  {`Upload Version ${
                                    latestFile
                                      ? latestFile.versionNumber + 1
                                      : 1
                                  } (with edits)`}
                                </CustomButton>
                              ) : (
                                <Typography>{`Version ${
                                  latestFile ? latestFile.versionNumber + 1 : 1
                                } (with edits)`}</Typography>
                              )}
                            </Grid>

                            {/* Drag & Drop file area */}
                            <Grid item xs={7}>
                              {!approveClicked &&
                              exceptionRow?.requireSponsorSMEReview === true ? (
                                <Dropzone
                                  disabled
                                  accept=".csv,.xls,.xlsx,.pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx"
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div
                                      {...getRootProps({
                                        className: "dropzone",
                                        onDrop: (event) =>
                                          event.preventDefault(),
                                      })}
                                      // className={classes.files}
                                      style={{
                                        border: "1px solid #707070",
                                        display: "flex",
                                        alignItems: "center", // Align content vertically
                                        justifyContent: "space-between", // Space out text and icon
                                        //   padding: "10px",
                                      }}
                                    >
                                      <input {...getInputProps()} />

                                      {/* Text for the dropzone */}
                                      <Typography
                                        variant="body2"
                                        style={{
                                          cursor: "pointer",
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        Drag &amp; drop or click here to upload
                                        files
                                      </Typography>

                                      {/* Upload icon aligned to the right */}
                                      <PublishIcon
                                        fontSize="large"
                                        style={{
                                          marginLeft: "auto", // Push icon to the right
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                  )}
                                </Dropzone>
                              ) : (
                                <Typography>-NA-</Typography>
                              )}
                            </Grid>
                          </Grid>
                          {/* Approve/Reject Remarks */}
                          {exceptionRow?.requireSponsorSMEReview === true && (
                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Approve / Reject Remarks
                                </Typography>
                              </Grid>
                              <Grid item xs={7}>
                                {!approveClicked ? (
                                  <TextField
                                    placeholder="Enter remarks here"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    size="small"
                                    value={remarks} // Bind the state to the TextField value
                                    // onChange={handleRemarksChange} // Trigger the handler on change
                                  />
                                ) : (
                                  <Typography>
                                    {remarks ? remarks : "-NA-"}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          )}

                          {approveClicked &&
                            localStorage.collabType === "Pharma Co" && (
                              <Grid
                                container
                                spacing={3}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Grid item xs={5}>
                                  <Typography>Approved By</Typography>
                                </Grid>
                                <Grid item xs={7}>
                                  <Typography>
                                    {profileDetails.full_name} on{" "}
                                    {moment().format("DD-MM-YYYY")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                          {/* Approve/Reject Buttons */}
                          {exceptionRow?.requireSponsorSMEReview === true && (
                            <>
                              {!approveClicked && (
                                <Grid
                                  container
                                  spacing={3}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Grid item xs={5}>
                                    {/* <Typography
                                      style={{
                                        marginBottom: "12px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Sponsor SME (User)
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      select
                                      value={SMEUserName}
                                      variant="outlined"
                                      size="small"
                                      style={{ marginBottom: "1rem" }}
                                      onChange={(e, value) =>
                                        SetSMEUserName(e.target.value)
                                      }
                                    >
                                      {exceptionRow.sponsorSMEUserNameList.map(
                                        (each, index) => (
                                          <MenuItem key={index} value={each}>
                                            {each}
                                          </MenuItem>
                                        )
                                      )}
                                    </TextField> */}
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Grid
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <CustomButton
                                        color="#28A745"
                                        textColor="#fff"
                                        onClick={handleApproveClick}
                                      >
                                        Approve
                                      </CustomButton>

                                      <CustomButton
                                        color="#DC3545"
                                        textColor="#fff"
                                      >
                                        Reject
                                      </CustomButton>
                                      <CustomButton
                                        color="#F26336" // Custom orange background
                                        hoverColor="#D8542E" // Darker orange on hover
                                        textColor="#fff"
                                      >
                                        Remind CMO Team
                                      </CustomButton>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </>
                          )}
                        </>
                      )}
                      {/* )} */}
                      {/* {row.qaApprovalRequired && ( */}
                      {localStorage.collabType === "Pharma Co" && (
                        <>
                          {exceptionRow?.requireSponsorSMEReview === true && (
                            <Grid container spacing={3}>
                              <Grid xs={12}>
                                <div className={classes.divider}></div>
                              </Grid>
                            </Grid>
                          )}

                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                QA Approval
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <TextField
                                placeholder="Enter remarks here"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                multiline
                                size="small"
                                value={qaRemarks} // Bind the state to the TextField value
                              />
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            spacing={3}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Grid item xs={5}></Grid>
                            <Grid item xs={7}>
                              <Grid
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <CustomButton
                                  color="#28A745"
                                  textColor="#fff"
                                  disabled={
                                    !approveClicked &&
                                    exceptionRow?.requireSponsorSMEReview ===
                                      true
                                  }
                                >
                                  Approve
                                </CustomButton>

                                <CustomButton
                                  color="#DC3545"
                                  textColor="#fff"
                                  disabled={
                                    !approveClicked &&
                                    exceptionRow?.requireSponsorSMEReview ===
                                      true
                                  }
                                >
                                  Reject
                                </CustomButton>
                                <CustomButton
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff"
                                  disabled={
                                    !approveClicked &&
                                    exceptionRow?.requireSponsorSMEReview ===
                                      true
                                  }
                                >
                                  Remind CMO Team
                                </CustomButton>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      )}
                      {/* )} */}

                      {/* </Grid> */}
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>

      {isDialogOpen && (
        <FileViewer
          openFileView={isDialogOpen}
          file={selectedFile}
          handleFileViewClose={handleCloseDialog}
          row={row}
          deliverablesData={deliverablesData}
          workItemDetails={workItemDetails}
          sponsorFileDetails={sponsorFileDetails}
          cdmoFileDetails={cdmoFileDetails}
          supportingFiles={supportingFiles}
          sponsorOrgID={deliverablesData?.sponsorOrgID}
          cdmoOrgID={deliverablesData?.cdmoOrgID}
        />
      )}
    </>
  );
};

export default ExceptionCollabpisbleRow;
